'use strict';

angular
	.module('bringgApp')
	.controller(
		'IndexController',
		function (
			$scope,
			localStorageService,
			$rootScope,
			AuthenticationUtils,
			Authentication,
			ManagerActionAuthorizationService,
			MerchantService,
			SubmitTicketService,
			CrossApplicationService,
			CROSS_APP_ACTIONS,
			SUBSCRIPTION_TYPE,
			bringg_utils,
			MerchantConfigurations,
			BRINGG_NOW_CHECKOUT_FLOW,
			IdentityProvider,
			$window,
			BringgSDK
		) {
			BringgSDK.initSdkConfiguration();

			$scope.newNavigation = localStorageService.get('newNavigation');
			$scope.isO2MUser = false;

			$scope.configure = function () {
				if ($scope.isO2MUser) {
					bringg_utils.updateO2MColors(MerchantConfigurations.header_color);
				}
			};

			MerchantService.get().then(function (merchant) {
				$scope.isO2MUser = merchant.subscription_type === SUBSCRIPTION_TYPE.O2M;
			});

			$rootScope.$watch(Authentication.isLoggedIn, function () {
				if (Authentication.isLoggedIn()) {
					ManagerActionAuthorizationService.init();

					Authentication.featureFlags().then(function (featureFlags) {
						$scope.newNavigation = _.isUndefined(featureFlags.new_navigation)
							? $scope.newNavigation
							: featureFlags.new_navigation;
						localStorageService.set('newNavigation', $scope.newNavigation);
					});
				}
			});

			IdentityProvider.byToken().catch(function () {});

			$rootScope.$watch(AuthenticationUtils.isPartialLogin, function (isPartial) {
				$scope.isPartial = !!isPartial;
			});

			CrossApplicationService.on(CROSS_APP_ACTIONS.SUBMIT_TICKET, function () {
				SubmitTicketService.open();
			});
		}
	);
